import React , { useEffect , useState} from 'react'
import Table from '../../components/table'
import { getCandidateLeaveDetails } from "./services"

const LeavesDetails = (props: any) => {

  const [leaveDetails , setLeaveDetails ] = useState<any>()

  useEffect(() => {

    getLeaveDetails(1 , 25 , props.candidateData.candidateJobId)
    
  },[])

  const getLeaveDetails = (pageNumber: number , pageSize?: number, candidateJobId?: any) => {
    let data = {
      candidateJobId : candidateJobId
    }
    getCandidateLeaveDetails(pageNumber,pageSize,data).then((response) => {
      if(response && response.status === 1){
        setLeaveDetails(response.data)
      }
    })
  }

  return (
    <section>
      <Table type='candidateLeaveDetails' data={leaveDetails}/>
    </section>
  )
}

export default LeavesDetails